module.exports = "/packs/sns-icon-line-beb6238f247fa69b27fd3928f44893c0.png";